import { GetNotificationsOutput } from "../interfaces/RFXBackendModel";
import getNotifications from "./queries/getNotifications";

export default async function GetNotifications(
  client: any,
  startTime?: number,
  endTime?: number,
  nextToken?: string,
): Promise<GetNotificationsOutput>  {
  const getNotificationsQuery = getNotifications.bind(client);

  const getNotificationsVariables = {
    startTime,
    endTime,
    nextToken
  };
  
  let response = await getNotificationsQuery(getNotificationsVariables);
  return response;
}
